import React from "react";
import { observer } from "mobx-react";
import { Skeleton, WidgetEmptyErrorPlaceholder, Scrollbar } from "@ann/web-components";
import { ContentContainer, ColumnContainer, ErrorWrapper, EmptyWrapper, ScrollbarContainer } from "./Content.styled";
import CarCard from "../CarCard";

const Content = observer(({ loading, error, isEmpty, vehicles, contactId, onRefresh }) => {
  // Mover useMemo ANTES de los returns condicionales para cumplir con las reglas de hooks
  const [leftVehicles, rightVehicles] = React.useMemo(() => {
    if (!vehicles?.length) {
      return [[], []];
    }

    const left = [];
    const right = [];

    vehicles.forEach((vehicle, index) => {
      if (index % 2 === 0) {
        left.push(vehicle);
      } else {
        right.push(vehicle);
      }
    });

    return [left, right];
  }, [vehicles]);

  if (loading) {
    return (
      <ContentContainer>
        <Skeleton height="420px" width="100%" />
      </ContentContainer>
    );
  }

  if (error) {
    return (
      <ContentContainer>
        <ErrorWrapper>
          <WidgetEmptyErrorPlaceholder
            icon="error"
            title="Something went wrong"
            message="We couldn't load vehicle information. Please try again."
            buttonText="Retry"
            showButton={true}
            onClick={onRefresh}
          />
        </ErrorWrapper>
      </ContentContainer>
    );
  }

  if (isEmpty || !vehicles?.length) {
    return (
      <ContentContainer>
        <EmptyWrapper>
          <WidgetEmptyErrorPlaceholder
            icon="directionsCar"
            title="No vehicle data yet"
            message="We'll show vehicle info as soon as it's linked or confirmed."
            showButton={false}
          />
        </EmptyWrapper>
      </ContentContainer>
    );
  }

  return (
    <ContentContainer>
      <Scrollbar size="medium">
        <ScrollbarContainer>
          <ColumnContainer>
            {leftVehicles.map((vehicle) => {
              const vehicleUuid = vehicle?.vehicleUuid || vehicle?.vehicleInformation?.vehicleUuid || vehicle?.id;
              return (
                <CarCard key={vehicleUuid} vehicle={vehicle} contactId={contactId} />
              );
            })}
          </ColumnContainer>
          <ColumnContainer>
            {rightVehicles.map((vehicle) => {
              const vehicleUuid = vehicle?.vehicleUuid || vehicle?.vehicleInformation?.vehicleUuid || vehicle?.id;
              return (
                <CarCard key={vehicleUuid} vehicle={vehicle} contactId={contactId} />
              );
            })}
          </ColumnContainer>
        </ScrollbarContainer>
      </Scrollbar>
    </ContentContainer>
  );
});

export default Content;

